import { render, staticRenderFns } from "./UploadIdDocument.vue?vue&type=template&id=f2e8d504&scoped=true"
import script from "./UploadIdDocument.vue?vue&type=script&lang=js"
export * from "./UploadIdDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e8d504",
  null
  
)

export default component.exports